<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      title="Négociateurs"
      autocomplete_idHistory="negotiators"
      autocomplete_field="negotiateur.initiale || negotiateur.prenom || negotiateur.prenom"
      bdTable="negotiateur"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      ref="negotiator_resource"
      defaultOrder="active ASC , nom"
      defaultSort="ASC"
      @edit_negotiator="editNegotiator"
      @delete_negotiator="deleteNegotiator"
    >
      <template v-slot:cell(nom)="data">
        <b-icon-check-circle-fill class="mr-2" variant="success" v-if="data.item.active == 'yes'"></b-icon-check-circle-fill>
        <b-icon-x-circle-fill class="mr-2"  variant="danger" v-else></b-icon-x-circle-fill>
        <a @click.prevent="editNegotiator({ ID: data.item.ID })" href=""
        >{{ data.item.prenom }} {{ data.item.nom }} {{ data.item.initiale !== '' ? '(' + data.item.initiale + ')' : '' }}
        </a>
      </template>
      <template v-slot:cell(keycloak_sub)="data">
         <b-icon-check-circle-fill variant="success" v-if="data.item.keycloak_sub !== ''"></b-icon-check-circle-fill>
        <b-icon-x-circle-fill variant="danger" v-else></b-icon-x-circle-fill>
      </template>
      <template v-slot:cell(alert_attribution)="data">
         <b-icon-check-circle-fill variant="success" v-if="data.item.alert_attribution == 'yes'"></b-icon-check-circle-fill>
        <b-icon-x-circle-fill variant="danger" v-else></b-icon-x-circle-fill>
      </template>
      <template v-slot:cell(tel)="data">
        <a :href="'tel:+32' + data.item.tel.replace(/^0/g, '')">{{data.item.tel}}</a>
       
      </template>
      <template v-slot:cell(email)="data">
        <a :href="'mailto:' + data.item.email">{{data.item.email}}</a>
       
      </template>
      <template v-slot:cell(profile)="data">
        <span v-if="data.item.profile == 'negotiateur' && data.item.avocat == 'oui'">Avocat</span>
        <span v-else-if="data.item.profile == 'superadmin'">Super Administrateur</span>
        <span v-else-if="data.item.profile == 'admin'">Administrateur</span>
        <span v-else-if="data.item.profile == 'negotiateur'">Négociateur</span>
       
      </template>
      <template v-slot:menu>
        <b-button title="Nouveau négociateur" size="sm" icon variant="secondary" @click="newNegotiator" class="mb-3"
          ><b-icon-plus-circle-fill></b-icon-plus-circle-fill></b-button
        >
      </template>
    </bd-table-list>
    <b-modal
      id="modal-modifier-negotiator"
      size="lg"
      title="Modifier un négociateur"
      hide-footer
    >
      <Negotiator
        @change="$refs.negotiator_resource.submitSearch(false)"
        @close="$bvModal.hide('modal-modifier-negotiator')"
        :negotiator_id="negotiator_id"
      ></Negotiator>
    </b-modal>
    <b-modal
      id="modal-ajouter-negotiator"
      size="lg"
      title="Ajouter un nouveau négociateur"
      hide-footer
    >
      <Negotiator
        @change="$refs.negotiator_resource.submitSearch(false)"
        @close="$bvModal.hide('modal-ajouter-negotiator')"
        negotiator_id="new"
      ></Negotiator>
    </b-modal>
  </div>
  
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import negotiators from "@/services/negotiators.js";
import Negotiator from "@/components/Negotiator";
export default {
  name: "negotiators",
  components: {
    BdTableList, Negotiator
  },
  methods: {
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    connectKeycloak(id) {
      this.Api.connectKeycloak(id).then(response => {
        if(response.data.success) {
          this.$refs.negotiator_resource.submitSearch(false);
        }
      });
    },
    newNegotiator() {
      this.negotiator_id = "new";
      this.$bvModal.show("modal-ajouter-negotiator");
    },
    editNegotiator(payload) {
      this.negotiator_id = payload.ID;
      this.$bvModal.show("modal-modifier-negotiator");
    },
    deleteNegotiator(payload) {
      negotiators
        .delete_negotiator({
          negotiator_id: payload.ID,
        })
        .then((response) => {
          if (response.data.success) {
            this.$refs.negotiator_resource.submitSearch(true);
          }
        });
    },
  },
  data() {
    return {
      Api: negotiators,
      negotiator_id: null,
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Administration",
          to: { name: "administration"},
        },
        {
          text: "Négociateurs",
          active: true
        }
      ],
      actions: [
        {
          label: "Éditer",
          event: "edit_negotiator",
          icon: "pencil-square",
          variant: "success"
        },
        
      ],
      fields: [
        {
          key: "nom",
          label: "Nom",
          sortable: true,
          class: 'text-truncate'
        },
        {
          key: "langue",
          label: "Langue",
          sortable: true,
          thStyle: { width: '5%'}
        },
        {
          key: "profile",
          label: "Profil",
          thStyle: { width: '10%'}
        },
        {
          key: "keycloak_sub",
          label: "Accès v3",
          class: "text-center",
          thStyle: { width: '5%'}
        },
        {
          key: "alert_attribution",
          label: "Alerte attribution",
          class: "text-center",
          thStyle: { width: '10%'}
        },
        {
          key: "tel",
          label: "Téléphone"
        },
        {
          key: "gsm",
          label: "GSM"
        },
        {
          key: "email",
          label: "Email"
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: 'text-center',
          thStyle: "width:100px",
        },
      ],
    };
  },
    
};
</script>

<style lang="scss" scoped>
</style>